import { Tos, TosAcceptance } from '@libs/models';

import { api } from '../common.api';

type AcceptTosRequest = {
  email: string;
  timestamp: string;
  version: number;
  acceptedFrom: string;
};

export const tosApi = api.injectEndpoints({
  endpoints: (build) => ({
    acceptTos: build.mutation<void, AcceptTosRequest>({
      query: (body) => ({
        url: '/tos/acceptTos',
        method: 'POST',
        body,
      }),
    }),
    getLatestTosVersion: build.query<Tos, void>({
      query: () => ({
        url: '/tos/latestTosVersion',
        method: 'GET',
      }),
    }),
    getTosByVersion: build.query<Tos, number>({
      query: (version) => ({
        url: `/tos/version/${version}`,
        method: 'GET',
      }),
    }),
    latestAcceptedVersion: build.query<TosAcceptance, string>({
      query: (email) => ({
        url: `/tos/latestAccepted`,
        method: 'GET',
        params: { email },
      }),
    }),
    createTos: build.mutation<Tos, Tos>({
      query: (body) => ({
        url: '/tos/createTos',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useAcceptTosMutation,
  useGetLatestTosVersionQuery,
  useGetTosByVersionQuery,
  useLatestAcceptedVersionQuery,
  useCreateTosMutation,
} = tosApi;
